import React, { useState } from 'react';
import Slide0 from './Slide0';
import Slide1 from './Slide1';
import Slide2 from './Slide2';
import Slide3 from './Slide3';
import Slide4 from './Slide4';
import Slide5 from './Slide5';
import DeckNavigation from './DeckNavigation';
const DeckMC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 6;
  const goToNextSlide = () => {
    if (currentSlide < totalSlides - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };
  const goToPrevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };
  const slides = [<Slide0 key="slide0" data-id="element-2428" />, <Slide1 key="slide1" data-id="element-2429" />, <Slide2 key="slide2" data-id="element-2430" />, <Slide3 key="slide3" data-id="element-2431" />, <Slide4 key="slide4" data-id="element-2432" />, <Slide5 key="slide5" data-id="element-2433" />];
  return <div className="bg-gray-50 min-h-screen" data-id="element-2434">
      <div className="max-w-6xl mx-auto px-4 py-8" data-id="element-2435">
        {slides[currentSlide]}
        <DeckNavigation currentSlide={currentSlide} totalSlides={totalSlides} goToNextSlide={goToNextSlide} goToPrevSlide={goToPrevSlide} data-id="element-2436" />
      </div>
    </div>;
};
export default DeckMC;